import React from "react";

const TextTeamDeleteMessage = () => {
  return (
    <div>Для того чтобы удалить команду, сначала исключите из неё всех её членов и удалите все квизы из списка квизов команды.</div>
  )
}

export default TextTeamDeleteMessage